import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from '@ps-gui/shared-core';

export interface OcrSearchResult {
  pageId: string;
  wordRectLeft: number;
  wordRectTop: number;
  wordRectWidth: number;
  wordRectHeight: number;
  text: string;
  similarity: number;
}

export interface SearchQuery {
  searchString: string;
  similarityThreshold: number;
}

export type DocumentSearchQuery = SearchQuery & { documentIds: string[] };

@Injectable({
  providedIn: 'root',
})
export class DocumentSearchApiService extends ApiService {
  protected override get baseUrl(): string {
    return this.backendUrls.ctBackendUrl;
  }

  searchText(query: DocumentSearchQuery): Observable<OcrSearchResult[]> {
    return this.post('api/batch/ocr/search', query);
  }
}
